const EncryptUtils = {
    bin2String(array) {
        var result = "";
        for (var i = 0; i < array.length; i++) {
            result += String.fromCharCode(parseInt(array[i], 2));
        }
        return result;
    },
    string2Bin(str) {
        var result = [];
        for (var i = 0; i < str.length; i++) {
            result.push(str.charCodeAt(i).toString(2));
        }
        return result;
    },
    encryptPassword(password) {

        var base64 = null;
        var finalPass = null;

        finalPass = password.replace("ی", "ي").replace("ک", "ربقتلسمو").replace("ك", "ربقتلسمو");
        var windowsBytes = new TextEncoder("windows-1256").encode(finalPass);

        ////console.log(windowsBytes);

        //base64 = Base64.encodeToString(windowsBytes, Base64.DEFAULT);
        //var decoder = new TextDecoder('utf8');
        //base64 = btoa(decoder.decode(windowsBytes));
        base64 = Buffer.from(windowsBytes, 'utf8').toString('base64');

        ////console.log(base64);

        return base64;
    },

};

export default EncryptUtils;